export const blockIconsSocialPerson = (
	<span className='material-symbols-outlined'>person</span>
);
